export const isEmail = (text: any) => {
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!reg.test(text) && text !== '') {
      return false;
    } else {
      return true;
    }
  };
  